export function AttributeBadge({ label, value }) {
  return (
    <span className="rm-badge">
      <span className="rm-badge__label">{label}:</span> {value}
    </span>
  );
}
